import { createClient, type SupabaseClient } from '@supabase/supabase-js';

import { getEnv } from '@/lib/env';
import type { Database } from '@/types/database';

export type AppSupabaseClient = SupabaseClient<Database>;

let client: AppSupabaseClient | undefined;

/**
 * Single, lazily created browser Supabase client.
 * Uses only the anon/publishable key; authorization is enforced by RLS.
 */
export function getSupabaseClient(): AppSupabaseClient {
  if (!client) {
    const env = getEnv();
    client = createClient<Database>(env.VITE_SUPABASE_URL, env.VITE_SUPABASE_ANON_KEY, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        flowType: 'pkce',
      },
    });
  }
  return client;
}
